import {Fade, Hidden, Slide} from '@material-ui/core'
import {TransitionProps} from '@material-ui/core/transitions'
import React from 'react'

const DialogTransition = React.forwardRef(function Transition(
  props: TransitionProps & {children?: React.ReactElement<any, any>},
  ref: React.Ref<unknown>,
) {
  return (
    <>
      <Hidden mdUp>
        <Slide ref={ref} direction="up" {...props} />
      </Hidden>
      <Hidden smDown>
        <Fade ref={ref} {...props} />
      </Hidden>
    </>
  )
})

export default DialogTransition
